import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.scss';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import Routes from './Routes';
import { ContextProvider } from './pages/common/Context';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const root = ReactDOM.createRoot(document.getElementById('root'));
const fallback = 
  <div className="grid place-content-center place-items-center min-h-screen">
    <Spin indicator={<LoadingOutlined spin className='text-[#6B0121]' />} size="large" />
  </div>
  root.render(
	  <ContextProvider value="test">
	  	<Suspense fallback={fallback}>
        <RouterProvider router={Routes} />
      </Suspense>
	  </ContextProvider>
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
